export type ButtonFunctionType =
  | 'empty'
  | 'line'
  | 'rollover'
  | 'speed_dial'
  | 'presence'
  | 'parking_slot'
  | 'voicemail'

export type ButtonFunctionOption = {
  value: string
  label: string
  type?: ButtonFunctionType
  presetValue?: string
  presetLabel?: string
  disabled?: boolean
}

export interface DraftButton {
  _sortId: string
  type: 'LineButton' | 'SidecarButton'
  display_count: number
  extension_id: number | ''
  button_label: string
  button_function: string
  button_value: string
  speed_dial_value: string
  slot_number?: number
}

export const BUTTON_FUNCTION_OPTIONS: ButtonFunctionOption[] = [
  { value: '', label: 'Blank' },
  { value: 'line', label: 'Line', type: 'line' },
  { value: 'rollover', label: 'Rollover', type: 'rollover' },
  { value: 'speed_dial', label: 'Speed Dial', type: 'speed_dial' },
  { value: 'presence', label: 'BLF / Presence', type: 'presence' },
  { value: 'parking_slot', label: 'Parking Lot', type: 'parking_slot' },
  { value: 'voicemail', label: 'Shared Voicemail', type: 'voicemail' },
  { value: 'divider', label: '------------', disabled: true },
  {
    value: 'speed_dial__mango_support',
    label: 'Mango Support',
    type: 'speed_dial',
    presetValue: '4354662646',
    presetLabel: 'Mango Support',
  },
  {
    value: 'speed_dial__star10',
    label: 'Login Queue',
    type: 'speed_dial',
    presetValue: '*10',
    presetLabel: 'Login Q',
  },
  {
    value: 'speed_dial__star11',
    label: 'Logout Queue',
    type: 'speed_dial',
    presetValue: '*11',
    presetLabel: 'Logout Q',
  },
  {
    value: 'speed_dial__star999',
    label: 'Block Caller',
    type: 'speed_dial',
    presetValue: '*999',
    presetLabel: 'Block',
  },
  {
    value: 'speed_dial__star3',
    label: 'Open/Close',
    type: 'speed_dial',
    presetValue: '*3',
    presetLabel: 'Open/Close',
  },
  {
    value: 'dtmf__star20',
    label: 'Pause/Resume Recording',
    type: 'speed_dial',
    presetValue: '*20',
    presetLabel: 'Pause/Resume',
  },
  {
    value: 'speed_dial__star98',
    label: 'Alternate VM',
    type: 'speed_dial',
    presetValue: '*98',
    presetLabel: 'Alt VM',
  },
  {
    value: 'speed_dial__star60',
    label: '911 History',
    type: 'speed_dial',
    presetValue: '*60',
    presetLabel: '911 Hist',
  },
]

export const SIDECAR_ALLOWED_OPTION_VALUES = new Set([
  '',
  'speed_dial',
  'presence',
  'parking_slot',
  'voicemail',
  'speed_dial__mango_support',
  'speed_dial__star10',
  'speed_dial__star11',
  'speed_dial__star999',
  'speed_dial__star3',
  'dtmf__star20',
  'speed_dial__star98',
  'speed_dial__star60',
  'divider',
])

export const CORDLESS_BASE_MODEL_NAMES = new Set([
  'W52P',
  'W60B',
  'W70B',
  'AX83H',
])

export const BUTTON_FUNCTION_OPTION_BY_VALUE = new Map(
  BUTTON_FUNCTION_OPTIONS.map((option) => [option.value, option] as const),
)

export const LEGACY_PARKING_LOTS = [
  ...Array.from({ length: 99 }, (_, i) => 5901 + i),
  ...Array.from({ length: 900 }, (_, i) => 59100 + i),
]

export const FUNCTIONS_USING_EXTENSION_VALUE = new Set([
  'line',
  'presence',
  'voicemail',
  'rollover',
  'speed_dial',
  'dtmf',
])

export const getButtonFunctionOption = (value: string) =>
  BUTTON_FUNCTION_OPTION_BY_VALUE.get(value)
